export interface PdfViewerPayload {
  title: string
  src: string
  filename?: string
}

export const PDF_VIEWER_EVENT = 'ecofarte:open-pdf'

export function openPdfViewer(payload: PdfViewerPayload) {
  window.dispatchEvent(new CustomEvent<PdfViewerPayload>(PDF_VIEWER_EVENT, { detail: payload }))
}
